












































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import * as carPointApi from "@/api/car/index";
import * as notificationService from "@/services/notification/index";
import i18n from "@/i18n";

@Component({
  name: "CarFindModal",
})
export default class CarFindModal extends Vue {
  @Prop({ type: Boolean, default: false }) private isVisible!: boolean;

  isLoading: boolean = false;

  private carCode: string = "";

  @Emit("onsubmit")
  public emitConfirmAction() {
    const carCode = this.carCode;
    this.carCode = "";
    return carCode;
  }

  private async searchByCar() {
    this.isLoading = true;

    if (this.carCode == null) return;

    try {
      const response = (await carPointApi.findFarmByCar(this.carCode)).data;

      if (
        response.ruralInfo.length === 0 ||
        Object.keys(response).length === 0
      ) {
        this.$emit("cancelCreation");
        this.$emit("oncancel");
        notificationService.addErrorNotification(
          i18n.t("notifications.error.search-by-car-empty") as string
        );
        return;
      } else {
        // TODO: verificar se tem mais de uma opção de CAR
        this.$emit("onsubmit", response.ruralInfo[0]);
      }
    } catch (e) {
      notificationService.addErrorNotification(
        i18n.t("notifications.error.search-by-car-error") as string
      );
    } finally {
      this.isLoading = false;
      this.carCode = "";
      this.$emit("emitCancelAction");
    }
  }

  @Emit("oncancel")
  public emitCancelAction() {
    this.carCode = "";
  }
}
